import React, { useEffect, useState } from "react";
import Paper from "Components/UI/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { price2StringPrice } from "utils/priceformatter";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth } from "Hooks/useAuth";
import DateWithClear from "Components/UI/Form/DateWithClear";
import { getBalances, getReskontra } from "API/swesum";
import { getBalancesMySite, getReskontraMySite} from "API/myPages"
import { Skeleton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Download } from "@mui/icons-material";
import { usePopupNotificationContext } from "Context/NotificationPopup";
export default function AboutClient({ data, clientId, loading }) {
  const navigate = useNavigate();
  const { openError, openSuccess } = usePopupNotificationContext();
  const { isAdmin } = useAuth();
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [loadingReskontra, setLoadingReskontra] = useState(false);
  const [historyDate, setHistoryDate] = useState(null);
  const [displayHistory, setDisplayHistory] = useState(0);
  const [balance, setBalance] = useState({
    reskontra: 0,
    finansierat: 0,
    service: 0,
    återköpt: 0,
  });

  const handleNavigate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    navigate(
      `/books?clientId=${clientId}&date=${dayjs(date).format("YYYY-MM-DD")}`
    );
  };

  const downloadReskontra = async () => {
    try {
      setLoadingReskontra(true);

      if (historyDate === null) {
        openError("Inget datum är valt.");
        return;
      }
      if(isAdmin){
        var result = await getReskontra(clientId, historyDate);  
      }
      else{
        var result = await getReskontraMySite(clientId, historyDate);
      }
      

      const byteCharacters = atob(result.data.Data.FileContent);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = result.data.Data.FileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoadingReskontra(false);
    }
  };

  async function getHistoryReskontra(date) {
    if (date === "Invalid Date") {
      setHistoryDate(null);
      setDisplayHistory(0);
      return;
    }

    setHistoryDate(date);
    setDisplayHistory(1);

    var body = {
      Filters: [
        {
          Column: "Day",
          Value: date,
          Operation: 0,
          Or: false,
        },
      ],
      Order: {
        Column: "Day",
        Order: 0,
      },
      Page: 0,
      PageSize: 100,
    };

   try {
      setLoadingHistory(true);
      if(isAdmin){
        var balances = await getBalances(body, clientId);
      }
      else{
        var balances = await getBalancesMySite(clientId,body);
      }
      
      setBalance({
        reskontra: getSumOfAccountCharts(["1553", "1521"], balances, true) * -1,
        finansierat: getSumOfAccountCharts(["1553"], balances, true) * -1,
        service: getSumOfAccountCharts(["1521"], balances, true),
        återköpt: getSumOfAccountCharts(["1372"], balances, true) * -1,
      });
    } catch (err) {
      console.error("Failed to fetch balances", err);
    } finally {
      setLoadingHistory(false);
    }
  }

  function getSumOfAccountCharts(
    accountCharts,
    balances,
    daybalance = false,
    kredit = false,
    debit = false
  ) {
    if (!balances || balances.length === 0) return 0;

    return Math.ceil(
      balances.reduce((sum, item) => {
        const value = daybalance
          ? item.Daybalance
          : kredit
          ? item.KreditAmount
          : debit
          ? item.DebetAmount
          : 0 || 0;

        return accountCharts.includes(item.AccountChartNumber)
          ? sum + value
          : sum;
      }, 0)
    );
  }

  function CreateRow(
    title,
    price,
    { onClick = null, cursor = "default" } = {}
  ) {
    const clickable = typeof onClick === "function";

    return (
      <div
        onClick={clickable ? onClick : undefined}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          cursor: clickable ? cursor : "default",
        }}
      >
        <Typography variant="subtitle2">{title}</Typography>

        <Typography variant="subtitle2">
          {loading ? (
            <Skeleton height={20} width={100} />
          ) : price != null ? (
            price2StringPrice(price)
          ) : null}
        </Typography>
      </div>
    );
  }

  useEffect(() => {
    setHistoryDate(null);
    setDisplayHistory(0);
  }, [clientId]);

  return (
    <>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          alignItems: "stretch",
          gap: "5px",
        }}
      >
        <>
          {CreateRow("Reskontra", data?.Data?.LedgerSum)}
          <Box
            sx={{
              marginLeft: "3px",
              padding: "3px",
              border: "1px solid #ebebeb",
            }}
          >
            {CreateRow("Fakturor", data?.Data?.InvoiceSum)}
            {CreateRow("Kreditnotor", data?.Data?.CreditNoteSum)}
          </Box>
          <Box
            sx={{
              marginLeft: "3px",
              padding: "3px",
              border: "1px solid #ebebeb",
            }}
          >
            {CreateRow("Finansierat", data?.Data?.Purchase)}
            {CreateRow("Återköpt", data?.Data?.Regress)}
            {CreateRow("Service", data?.Data?.Service)}
          </Box>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {CreateRow("Finansierad limit", data?.Data?.CreditSpace)}
          </div>

          <Box sx={{ marginTop: "auto" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {CreateRow("Avräkningskonto", data?.Data?.AccountBalance, {
                onClick: () => handleNavigate(),
                cursor: "pointer",
              })}
            </Box>
          </Box>

            <>
              <Typography variant="subtitle2" sx={{ paddingTop: "2rem", textAlign: "left" }}>
                Historisk reskontra
              </Typography>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <DateWithClear
                  label="Fakturadatum"
                  value={dayjs(historyDate)}
                  onChange={(val) =>
                    getHistoryReskontra(dayjs(val).format("YYYY-MM-DD"))
                  }
                />
                <div
                  title={loadingReskontra ? "Laddar..." : "Ladda ned Excel"}
                  onClick={!loadingReskontra ? downloadReskontra : undefined}
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    cursor: loadingReskontra ? "wait" : "pointer",
                    opacity: loadingReskontra ? 0.6 : 1,
                  }}
                >
                  {loadingReskontra ? (
                    <CircularProgress size={24} thickness={5} />
                  ) : (
                    <Download fontSize="medium" />
                  )}
                </div>
              </div>
              <div
                style={{
                  position: "relative",
                  opacity: displayHistory ? 1 : 0,
                  transform: displayHistory ? "scale(1)" : "scale(0.95)",
                  transition: "opacity 0.3s ease, transform 0.3s ease",
                  pointerEvents: displayHistory ? "auto" : "none",
                  marginTop: 12,
                }}
              >
                {/* Spinner overlay */}
                {loadingHistory && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgba(255,255,255,0.6)",
                      zIndex: 5,
                    }}
                    aria-live="polite"
                    aria-busy="true"
                  >
                    <CircularProgress />
                  </Box>
                )}
              </div>
            </>
        </>
      </Paper>
    </>
  );
}
